import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__base_ui_components_react_radio_aafdad31__ from "@base-ui-components/react/radio";
import * as __WEBPACK_EXTERNAL_MODULE__utils_index_js_02c78a7f__ from "../../../utils/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__Radio_variants_js_6e2eb5f8__ from "./Radio.variants.js";
function RadioButton(props) {
    const { value, disabled, emphasis, radioButtonClassName, name, size = '20' } = props;
    const { radioRoot, radioIndicator } = (0, __WEBPACK_EXTERNAL_MODULE__Radio_variants_js_6e2eb5f8__.radioButtonVariants)({
        emphasis,
        size,
        state: disabled ? 'disabled' : 'enabled'
    });
    const classes = (0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_02c78a7f__.cn)(radioRoot(), radioButtonClassName);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_radio_aafdad31__.Radio.Root, {
        value: value,
        className: classes,
        disabled: disabled,
        name: name,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_radio_aafdad31__.Radio.Indicator, {
            className: radioIndicator()
        })
    });
}
export { RadioButton };
